import { VideoTypeId, VideoTypes } from 'components/Contentful/VideoPlayer';
import { ReactElement } from 'react';
import { IFragmentYouTubeVideo } from 'types/contentful';

export const isYoutubeVideoGuard = (
  videoObject: VideoTypes
): videoObject is IFragmentYouTubeVideo => {
  return (videoObject as IFragmentYouTubeVideo).sys.contentType.sys.id === VideoTypeId.Youtube;
};

type Props = {
  video: IFragmentYouTubeVideo;
  isAutoPlay?: boolean;
  isMuted?: boolean;
  isLooped?: boolean;
};

export default function YouTube({
  video,
  isAutoPlay = false,
  isMuted = false,
  isLooped = true,
}: Props): ReactElement {
  const src = `https://www.freshpaint-hipaa-videos.com/youtube/embed/${
    video.fields.videoId
  }?controls=0&autoplay=${isAutoPlay ? '1' : '0'}&mute=${isMuted ? '1' : '0'}&loop=${
    isLooped ? '1' : '0'
  }&playlist=${isLooped ? video.fields.videoId : ''}`;

  return (
    <iframe
      src={src}
      title="YouTube video player"
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
}
